import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Menu,
  MenuItem,
  Avatar,
} from "@mui/material";
import { RxActivityLog } from "react-icons/rx";
import { HiBell } from "react-icons/hi";
import { HiQuestionMarkCircle } from "react-icons/hi";
import { TbSettingsFilled } from "react-icons/tb";
import profilePic from "assets/images/profile.jpg";
import { IoIosArrowDown } from "react-icons/io";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MenuIcon from '@mui/icons-material/Menu';
import { MAIN_ROLES } from "config";
import { useAuth } from "context/AuthContext";
import { PUBLIC_URL } from "config";
import { FaUserCircle } from "react-icons/fa";
import { enterpriseTokens } from "styles/theme";
import { useGetProjectDetailQuery } from "store/slices/apis/projectApiSlice";

const TopNavBar = ({ isOpen, handleDrawer }) => {
  const [activeMenu, setActiveMenu] = useState("");
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { projectId } = useParams();
  const { data: projectDetail } = useGetProjectDetailQuery(projectId, { skip: !projectId });
  const projectName = projectDetail?.data?.projectName || "Project";
  const selectedPortfolio = localStorage.getItem("portfolioName") || projectDetail?.data?.projectType || "Portfolio";
  const [settingsAnchor, setSettingsAnchor] = useState(null);
  const openSettings = Boolean(settingsAnchor);
  const [amMenuAnchor, setAmMenuAnchor] = useState(null);
  const openAmMenu = Boolean(amMenuAnchor);

  const { pathname } = useLocation();
  const { user } = useAuth();
  const userDisplayName = [user?.firstName, user?.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();
  const loggedInAs = userDisplayName || user?.displayName || user?.name || user?.email || user?.userName || "Signed in user";
  const loggedInEmail = user?.email || user?.userName;
  const canManageUsers = user?.roles?.includes(MAIN_ROLES[0]);


  const HeaderTextStyle = (isActive) => ({
    fontWeight: isActive ? 700 : 600,
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0px",
    color: isActive ? enterpriseTokens.primary : enterpriseTokens.slate,
    fontFamily: "Inter, Outfit, sans-serif",
    cursor: "pointer",
    position: "relative",
    px: 0.75,
    py: 0.5,
    borderRadius: "5px",
    backgroundColor: isActive ? "#EAF2FF" : "transparent",
    transition: "all 160ms ease",
    "&:hover": {
      color: enterpriseTokens.primary,
      backgroundColor: enterpriseTokens.surfaceAlt,
    },
    "&::after": isActive
      ? {
        content: '""',
        position: "absolute",
        bottom: -8,
        left: "12%",
        right: "12%",
        height: "3px",
        backgroundColor: enterpriseTokens.primary,
        borderRadius: "999px",
        margin: "0 auto",
      }
      : {},
  });


  React.useEffect(() => {
    if (pathname.includes("/user-management/")) {
      setActiveMenu("Users & Roles");
    } else if (pathname.includes("/project-list") || (pathname.includes("/projects") && !pathname.includes("/user-management/"))) {
      setActiveMenu("");
    } else if (pathname.includes("/dashboard")) {
      setActiveMenu("Program Dashboard");
    } else if (pathname.includes("/my-work-dashboard")) {
      setActiveMenu("My Workspace");
    }

  }, [pathname]);

  const handleAmMenuOpen = (event) => {
    setAmMenuAnchor(event.currentTarget);
  };

  const handleAmMenuClose = () => {
    setAmMenuAnchor(null);
  };

  // const HeaderTextStyle = (isActive) => ({
  //     fontWeight: isActive ? 500 : 400,
  //     fontSize: "12px",
  //     lineHeight: "24px",
  //     letterSpacing: "-0.1px",
  //     color: isActive ? "#0E73F6" : "#252C32",
  //     fontFamily: "Outfit, sans-serif",
  //     cursor: "pointer",
  //     position: "relative",
  //     "&::after": isActive
  //         ? {
  //             content: '""',
  //             position: "absolute",
  //             //bottom: -15,
  //             bottom: { xs: -21, sm: -15 },
  //             left: -5,
  //             right: 0,
  //             height: "4px",
  //             backgroundColor: "#007BFF",
  //             borderRadius: "2px",
  //             width: "106%",
  //             margin: "0 auto",
  //         }
  //         : {},
  // });

  const DownArrowStyle = (isActive) => ({
    position: "relative",
    top: "1px",
    ml: "6px",
    color: isActive ? enterpriseTokens.primary : enterpriseTokens.muted,
  });
  const menuItems = [
    { label: "My Workspace", path: "/my-work-dashboard", rolesAllowed: MAIN_ROLES },
    // { label: "Program Dashboard", path: "/dashboard" },
    { label: "Action Tracker", hasArrow: false, path: "/action-tracker", rolesAllowed: MAIN_ROLES },
    // { label: "AM Tracker", hasArrow: true, rolesAllowed: MAIN_ROLES },
    { label: "AM Tracker", hasArrow: true, rolesAllowed: MAIN_ROLES },
  ];

  const amTrackerMenuItems = [
    { name: "IRR", path: "/irr-view-tracker" },
    { name: "Revenue & Leasing", path: "/revenue-leasing-tracker" },
    { name: "CAM", path: "/cam-tracker" },
    { name: "Insurance", path: "/insurance-tracker" },
    { name: "Operating Cost", path: "/operatingCost-tracker" },
    // { name: "Construction/Development", path: "/construction-development-tracker" },
  ];


  // const menuItems = [
  //     { label: "View Portfolio", path: "/portfolio" },
  //     { label: "Program Dashboard", path: "/dashboard" },
  //     { label: "Projects", hasArrow: true, path: "/project-list" },
  //     { label: "People", hasArrow: true, path: "/user-management/users" },
  // ];

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleCloseMenu();
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
  };
  return (
    <>
      <AppBar
        position="fixed"
        color="default"
        elevation={0}
        sx={{
          borderBottom: "1px solid #E5E9EB",
          backgroundColor: "#FFFFFF",
          boxShadow: "none",
        }}
      >
        <Toolbar
          sx={{
            justifyContent: "space-between",
            minHeight: "auto !important",
            px: { xs: 2.5, sm: isOpen ? 3 : '16px' },
            py: { xs: 1, sm: 0.5 },
            gap: { xs: 1, sm: 0 },

            overflowX: { xs: "auto", sm: "visible" },
            overflowY: "hidden",
            whiteSpace: { xs: "nowrap", sm: "normal" },

            scrollbarWidth: { xs: "thin", sm: "auto" },

            "&::-webkit-scrollbar": {
              height: { xs: "4px", sm: "0px" },
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: { xs: "#ccc", sm: "transparent" },
              borderRadius: "3px",
            },
          }}
        >
          {/* Left Side */}
          <Box sx={{ display: "flex", gap: 1.25, alignItems: "center", flex: 1, minWidth: 0 }}>
            {projectId !== undefined &&
              <IconButton sx={{ p: 0.75, color: enterpriseTokens.slate, border: `1px solid ${enterpriseTokens.lineSoft}`, borderRadius: "3px" }} onClick={handleDrawer}>
                {isOpen ? <MenuOpenIcon sx={{ height: '25px', width: '25px' }} /> : <MenuIcon sx={{ height: '25px', width: '25px' }} />}
              </IconButton>
            }

            <Box sx={{ display: "flex", alignItems: "center", pr: 1.5, borderRight: `1px solid ${enterpriseTokens.lineSoft}` }}>
              <Typography
                onClick={() => navigate("/portfolio")}
                aria-label="InfraTrack home"
                sx={{
                  fontFamily: "Inter, Outfit, sans-serif",
                  fontWeight: 700,
                  fontSize: "17px",
                  lineHeight: "22px",
                  color: enterpriseTokens.navy,
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                Infra<Box component="span" sx={{ color: enterpriseTokens.primary }}>Track</Box>
              </Typography>
            </Box>
            {(
              <Box
                aria-label="Current portfolio and project"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  minWidth: 0,
                  pr: 1.5,
                  borderRight: `1px solid ${enterpriseTokens.lineSoft}`,
                }}
              >
                <Box
                  onClick={() => navigate("/portfolio")}
                  title={selectedPortfolio}
                  sx={{ minWidth: 0, maxWidth: { xs: 110, md: 150 }, cursor: "pointer" }}
                >
                  <Typography sx={{ fontFamily: "Inter, Outfit, sans-serif", fontSize: "9px", lineHeight: "11px", fontWeight: 600, color: enterpriseTokens.muted, textTransform: "uppercase", letterSpacing: "0.05em" }}>
                    Portfolio
                  </Typography>
                  <Typography sx={{ fontFamily: "Inter, Outfit, sans-serif", fontSize: "12px", lineHeight: "16px", fontWeight: 600, color: enterpriseTokens.slate, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", "&:hover": { color: enterpriseTokens.primary } }}>
                    {selectedPortfolio}
                  </Typography>
                </Box>
                <Box sx={{ color: enterpriseTokens.muted, fontSize: "14px", lineHeight: 1 }}>/</Box>
                <Box
                  onClick={() => navigate("/project-list")}
                  title={projectId ? projectName : "Projects"}
                  sx={{ minWidth: 0, maxWidth: { xs: 130, md: 190 }, cursor: "pointer" }}
                >
                  <Typography sx={{ fontFamily: "Inter, Outfit, sans-serif", fontSize: "9px", lineHeight: "11px", fontWeight: 600, color: enterpriseTokens.muted, textTransform: "uppercase", letterSpacing: "0.05em" }}>
                    {projectId ? "Project" : "Workspace"}
                  </Typography>
                  <Typography sx={{ fontFamily: "Inter, Outfit, sans-serif", fontSize: "12px", lineHeight: "16px", fontWeight: 650, color: enterpriseTokens.navy, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", "&:hover": { color: enterpriseTokens.primary } }}>
                    {projectId ? projectName : "Projects"}
                  </Typography>
                </Box>
              </Box>
            )}
            {menuItems?.filter(item => {

              const isCustomer = user?.roles?.includes("Customer");

              if (isCustomer) return false;
              const hasRoleAccess =
                item?.rolesAllowed?.some(role => user?.roles?.includes(role));

              if (PUBLIC_URL?.includes(item?.label)) {
                return true;
              }
              return hasRoleAccess;
            })?.map((item) => {
              const isActive = activeMenu === item.label;

              if (item.label === "AM Tracker") {
                return (
                  <Typography
                    key={item.label}
                    variant="inherit"
                    component="span"
                    sx={{ ...HeaderTextStyle(isActive) }}
                    onClick={handleAmMenuOpen}
                  >
                    {item.label}
                    <Box component="span" sx={DownArrowStyle(isActive)}>
                      <IoIosArrowDown size={13} />
                    </Box>
                  </Typography>
                );
              }
              return (
                <>
                  <Typography
                    key={item.label}
                    variant="inherit"
                    component="span"
                    sx={{ ...HeaderTextStyle(isActive), ml: item.label === "My Workspace" ? "auto" : 0 }}
                    onClick={() => {
                      setActiveMenu(item.label);
                      navigate(item.path);
                    }}
                  >
                    {item.label}
                    {item.hasArrow && (
                      <Box component="span" sx={DownArrowStyle(isActive)}>
                        <IoIosArrowDown size={13} />
                      </Box>
                    )}
                  </Typography>
                </>
              );
              // return (
              //   <Typography
              //     key={item.label}
              //     variant="inherit"
              //     component="span"
              //     sx={{ ...HeaderTextStyle(isActive) }}
              //     onClick={() => {
              //       setActiveMenu(item.label);
              //       navigate(item.path);
              //     }}
              //   >
              //     {item.label}
              //     {item.hasArrow && (
              //       <Box component="span" sx={DownArrowStyle(isActive)}>
              //         <IoIosArrowDown size={13} />
              //       </Box>
              //     )}
              //   </Typography>
              // );
            })}
            {/* AM Tracker Menu */}
            <Menu
              anchorEl={amMenuAnchor}
              open={openAmMenu}
              onClose={handleAmMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
              sx={{ mt: 1 }}
            >
              {amTrackerMenuItems.map((item) => (
                <MenuItem
                  key={item.name}
                  onClick={() => {
                    handleAmMenuClose();
                    navigate(item.path);
                  }}
                >
                  {item.name}
                </MenuItem>
              ))}
            </Menu>

            {/* {menuItems.map((item) => {
              const isActive = activeMenu === item.label;
              return (
                <Typography
                  key={item.label}
                  variant="inherit"
                  component="span"
                    sx={{ ...HeaderTextStyle(isActive), ml: item.label === "My Workspace" ? "auto" : 0 }}
                  onClick={() => {
                    setActiveMenu(item.label);
                    navigate(item.path);
                  }}
                >
                  {item.label}
                  {item.hasArrow && (
                    <Box component="span" sx={DownArrowStyle(isActive)}>
                      <IoIosArrowDown size={13} />
                    </Box>
                  )}
                </Typography>
              );
            })} */}
          </Box>

          {/* Right Side */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.25 }}>
            <IconButton sx={{ color: enterpriseTokens.slate }}>
              <HiBell size={19} />
            </IconButton>
            <IconButton sx={{ color: enterpriseTokens.slate }}>
              <HiQuestionMarkCircle size={19} />
            </IconButton>
            {canManageUsers && (
              <>
                <IconButton
                  aria-label="Administration"
                  onClick={(event) => setSettingsAnchor(event.currentTarget)}
                  sx={{ color: enterpriseTokens.slate }}
                >
                  <TbSettingsFilled size={19} />
                </IconButton>
                <Menu
                  anchorEl={settingsAnchor}
                  open={openSettings}
                  onClose={() => setSettingsAnchor(null)}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                  PaperProps={{
                    elevation: 0,
                    sx: { mt: 1, minWidth: 180, border: `1px solid ${enterpriseTokens.lineSoft}`, borderRadius: "3px", boxShadow: "0 10px 30px rgba(15, 23, 42, 0.12)" },
                  }}
                >
                  <Box sx={{ px: 1.5, py: 1, borderBottom: `1px solid ${enterpriseTokens.lineSoft}` }}>
                    <Typography sx={{ fontFamily: "Inter, Outfit, sans-serif", fontSize: "10px", fontWeight: 700, color: enterpriseTokens.muted, textTransform: "uppercase", letterSpacing: "0.06em" }}>
                      Administration
                    </Typography>
                  </Box>
                  <MenuItem onClick={() => { setSettingsAnchor(null); navigate(projectId ? `/projects/${projectId}/user-management/users` : "/user-management/users"); }} sx={{ fontFamily: "Inter, Outfit, sans-serif", fontSize: "13px" }}>
                    Users
                  </MenuItem>
                  {projectId && (
                    <MenuItem onClick={() => { setSettingsAnchor(null); navigate(`/projects/${projectId}/user-management/roles`); }} sx={{ fontFamily: "Inter, Outfit, sans-serif", fontSize: "13px" }}>
                      Roles
                    </MenuItem>
                  )}
                </Menu>
              </>
            )}
            <IconButton
              onClick={handleOpenMenu}
              sx={{
                ml: 0.5,
                color: enterpriseTokens.primary,
                border: `1px solid ${enterpriseTokens.lineSoft}`,
                backgroundColor: enterpriseTokens.surfaceAlt,
              }}
            // sx={{ p: 0, ml: "5px", mb: "1px" }}
            >
              {/* <Avatar
                alt="User Profile"
                src={profilePic}
                sx={{ width: 35, height: 35 }}
              /> */}
              <FaUserCircle size={24} />
            </IconButton>

            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleCloseMenu}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Box
                sx={{
                  px: 2,
                  py: 1.25,
                  minWidth: 240,
                  borderBottom: "1px solid #E5E9EB",
                }}
              >
                <Typography
                  sx={{
                    color: "#252C32",
                    fontFamily: "Outfit, sans-serif",
                    fontSize: "12px",
                    fontWeight: 600,
                    lineHeight: "20px",
                    wordBreak: "break-word",
                  }}
                >
                  {loggedInAs}
                </Typography>
                {loggedInEmail && loggedInEmail !== loggedInAs && (
                  <Typography
                    sx={{
                      color: "#6E7C87",
                      fontFamily: "Outfit, sans-serif",
                      fontSize: "12px",
                      lineHeight: "18px",
                      wordBreak: "break-word",
                    }}
                  >
                    {loggedInEmail}
                  </Typography>
                )}
              </Box>
              <MenuItem onClick={handleLogout} sx={{ color: "red" }}>
                Logout
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </>
  );
};

export default TopNavBar;
